/* NgRx */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ManageUsersState } from './manage-users.reducer';


// Selector functions
const manageUsersData =
  createFeatureSelector<ManageUsersState>('ss-cord.manage-users');

export const clinicFilter = createSelector(
  manageUsersData,
  (state: ManageUsersState) => state.clinicFilter
);

export const statusFilter = createSelector(
  manageUsersData,
  (state: ManageUsersState) => state.statusFilter
);

export const groupFilter = createSelector(
  manageUsersData,
  (state: ManageUsersState) => state.groupFilter
);

export const usersList = createSelector(
  manageUsersData,
  (state: ManageUsersState) => state.usersList
);

export const rolesList = createSelector(manageUsersData, (state: ManageUsersState) => state.rolesList)


export const editUserStatusInfo = createSelector(
  manageUsersData,
  (state: ManageUsersState) => state.editUserStatusInfo
);

export const assignGroupLoading = createSelector(manageUsersData, (state: ManageUsersState) => state.assignGroupLoading)

export const updateUserStatusLoading = createSelector(manageUsersData, (state: ManageUsersState) => state.updatingUserStatus)
